import {
  Divider,
  Grid,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Container,
  Drawer,
  Box
} from '@mui/material'
import moment from 'moment'

function NewSubscriptionPurchaseDrawer({
  visible,
  title,
  onSave,
  onPay,
  onClose,
  onUserCountChange,
  entitlementData,
  selectedPlan,
  calculationData,
  noOfUsers
}) {
  if (calculationData == undefined) {
    calculationData = {
      subtotal: 0,
      total: 0,
      net_amount: 0,
      tillDate: '',
      suspend_users: 0,
      maxuserFlag: 1
    }
  }

  return (
    <div>
      <Drawer
        anchor="right"
        backdrop="static"
        variant="temporary"
        open={visible}
        onClose={onClose}
        PaperProps={{
          sx: {
            width: {
              lg: 400,
              md: 300
            }
          }
        }}
      >
        <Container sx={{ padding: 5 }}>
          <Box sx={{ textAlign: 'center' }}>
            <Typography
              style={{ fontSize: 14, fontWeight: 'bold', marginTop: 5 }}
              gutterBottom
            >
              {title}
            </Typography>
            <Divider spacing={10} />
          </Box>
          <Grid container spacing={2} sx={{ paddingTop: 5 }}>
            <Grid item md={6}>
              <TextField
                size="small"
                name="users"
                label="No of Users"
                // value={noOfUsers}
                value={'Unlimited'}
                variant="outlined"
                fullWidth
                margin="dense"
                disabled
                onChange={(e) => onUserCountChange(e.target.value)}
                my={2}
              />
            </Grid>
            <Grid item md={6}>
              <Typography style={{ fontSize: 14, paddingTop: 15 }} gutterBottom>
                Purchase Type : New
              </Typography>
            </Grid>
          </Grid>
          {calculationData.maxuserFlag && (
            <Grid
              container
              spacing={6}
              style={{ marginTop: 1, paddingLeft: 2, paddingRight: 2 }}
            >
              <Grid item md={12}>
                <Typography
                  style={{
                    marginTop: 8,
                    fontSize: 14,
                    color: 'red',
                    fontWeight: 'bold'
                  }}
                >
                  Active Users are higher than the allowed Users
                </Typography>
                <Typography
                  style={{
                    marginTop: 8,
                    fontSize: 14,
                    color: 'red',
                    fontWeight: 'bold'
                  }}
                >
                  Change Plan Or Suspend {calculationData.suspend_users} Users
                </Typography>
              </Grid>
            </Grid>
          )}

          <Grid
            container
            direction={'column'}
            spacing={1}
            style={{ marginTop: 1, paddingLeft: 2, paddingRight: 2 }}
          >
            <Grid item md={6}>
              <Typography
                style={{
                  marginTop: 8,
                  fontSize: 14,
                  fontWeight: 'bold'
                }}
              >
                From Date :{' '}
                {moment(new Date(entitlementData?.expiry_date)).format(
                  'DD-MM-YYYY'
                )}
              </Typography>
            </Grid>
            <Grid item md={6}>
              {/* <Typography
                style={{
                  marginTop: 8,
                  fontSize: 14,
                  fontWeight: 'bold'
                }}
              >
                Plan Expiry Date :{' '}
                {moment(new Date(calculationData.tillDate)).format(
                  'DD-MM-YYYY'
                )}
              </Typography> */}
            </Grid>
          </Grid>

          <Table size="small" style={{ marginTop: 15 }}>
            <TableHead>
              <TableRow>
                <TableCell>Plan Name</TableCell>
                <TableCell>Fixed Price</TableCell>
                <TableCell align="left"> Qty</TableCell>
                <TableCell align="left"> Unit Price</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell align="left">{selectedPlan?.name}</TableCell>
                <TableCell align="left">
                  Rs {selectedPlan?.fixed_charge}
                </TableCell>
                <TableCell align="left"> {noOfUsers || 0}</TableCell>
                <TableCell align="left">
                  Rs {selectedPlan?.price_per_user}
                </TableCell>
              </TableRow>
            </TableBody>
            <TableBody>
              <TableRow>
                <TableCell rowSpan={8} />
                <TableCell colSpan={2} style={{ fontWeight: 'bold' }}>
                  Fixed Price
                </TableCell>
                <TableCell align="left" style={{ fontWeight: 'bold' }}>
                  {selectedPlan?.fixed_charge}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={2} style={{ fontWeight: 'bold' }}>
                  Subtotal
                </TableCell>
                <TableCell align="left" style={{ fontWeight: 'bold' }}>
                  {calculationData.subtotal}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={2} style={{ fontWeight: 'bold' }}>
                  GST
                </TableCell>
                <TableCell align="left" style={{ fontWeight: 'bold' }}>
                  {' '}
                  {selectedPlan?.igst} %
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={2} style={{ fontWeight: 'bold' }}>
                  Total
                </TableCell>
                <TableCell align="left" style={{ fontWeight: 'bold' }}>
                  {' '}
                  {calculationData.total}{' '}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={2} style={{ fontWeight: 'bold' }}>
                  Credit Amount
                </TableCell>
                <TableCell align="left" style={{ fontWeight: 'bold' }}>
                  {' '}
                  {entitlementData?.credit_note ?? 0}{' '}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={2} style={{ fontWeight: 'bold' }}>
                  Net Amount
                </TableCell>
                <TableCell align="left" style={{ fontWeight: 'bold' }}>
                  {' '}
                  {calculationData.net_amount}{' '}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <Grid container spacing={6} sx={{ mt: 3 }}>
            <Grid item>
              <Button
                onClick={onPay}
                variant="outlined"
                size="small"
                color="primary"
                mt={3}
              >
                Pay {calculationData.net_amount}
              </Button>
            </Grid>
          </Grid>
        </Container>
      </Drawer>
    </div>
  )
}

export default NewSubscriptionPurchaseDrawer
